import React, { Component } from "react";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import teamInfo from "./teamInfo";

import styles from "./About.css";

class Team extends Component {
  render() {
    return (
      <div className={styles.aboutSections}>
        <div className={styles.sectionHeaders}>
          <h4>Team</h4>
        </div>

        <div className={styles.aboutContent}>
          <Row>
            {teamInfo.map((person, index) => {
              return (
                <Col key={index} md="4" lg="4" sm="6" xs="6">
                  <div>
                    <img src={person.picture} className={styles.teamPics} />
                  </div>
                  <div className={styles.teamNames}>
                    {person.name}
                  </div>
                  <div className={styles.teamTitles}>
                    {person.title}
                  </div>
                </Col>
              );
            }) }
          </Row>
        </div>
      </div>
    );
  }
}

export default Team;



// WEBPACK FOOTER //
// ./src/about/components/About/Team.js